import React from "react";
import { Redirect } from "react-router-dom";
import BlankLayout from "go-core/components/Layout/BlankLayout";
import { LoadingContainer } from "go-core/components/Loading";
import SessionIdService from "../../../services/session/sessionIdService";

const SecuritySaveSessionPage = () => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const referenceUrl = urlSearchParams.get("reference_uri");

	if (document.referrer === "") {
		if (referenceUrl) {
			window.location.href = referenceUrl;
		} else return <Redirect to={"/dashboard"} />;
	} else {
		const sessionId = urlSearchParams.get("session_id");
		if (sessionId && referenceUrl) {
			SessionIdService.update(sessionId);
			window.location.href = referenceUrl;
		}
	}

	return (
		<BlankLayout>
			<LoadingContainer />
		</BlankLayout>
	);
};
export default SecuritySaveSessionPage;
